export const naturallyelegant = {
  name: 'Naturally Elegant',
  color: [0.49411764705882355, 0.4823529411764706, 0.08235294117647059, 1],
  bg: [0.9215686274509803, 0.8745098039215686, 0, 1],
  grid1: [0.33725490196078434, 0.24313725490196078, 0.12549019607843137, 1],
  grid2: [0.788235294117647, 0.6196078431372549, 0.06274509803921569, 1],
}
